<template>
  <div class="menu-filter-container">
    <div class="row g-2 align-items-stretch">

      <div :class="[buscaAtiva ? 'col-12' : 'col-4 col-md-12', 'transition-layout p-0']">
        <div v-if="buscaAtiva || isDesktop" class="input-icon-container">
          <input type="text" class="form-control custom-input" placeholder="Buscar" v-model="termoBusca"
            ref="searchInput" @blur="checkBlur" @keyup.enter="aplicarBusca">
          <i class="fas fa-search search-icon" @click.prevent="aplicarBusca()"></i>

        </div>

        <div v-else class="btn-acao-mobile d-md-none" @click="ativarBuscaMobile">
          <i class="fas fa-search"></i>
          <span>Buscar</span>
        </div>
      </div>

      <div :class="[buscaAtiva ? 'col-6 mt-3' : 'col-4 col-md-12', 'transition-layout p-0']">
        <div id="btn-filtro-ancora" class="btn-acao-mobile">
          <i class="fas fa-filter mr-md-3"></i>
          <span>Filtros</span>
        </div>
      </div>

      <div :class="[buscaAtiva ? 'col-6 mt-3' : 'col-4 col-md-12', 'transition-layout p-0']">
        <div class="btn-acao-mobile ordenar-wrapper">
          <span class="d-none d-md-inline estilo-fonte label-desktop">Ordenar por:</span>

          <b-dropdown variant="link" class="custom-dropdown" no-caret boundary="viewport">
            <template #button-content>
              <i class="fas fa-sort d-md-none"></i>
              <span class="d-md-none">Ordenar</span>
              <span class="d-none d-md-inline text-selected-label">{{ selectedLabel }}</span>
            </template>
            <b-dropdown-item class="item-order" v-for="op in opcoesOrdenacao" :key="op.codigo"
              @click.prevent="selecionarOrdenacao(op)">
              {{ op.nome }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>

    <Filters @filtrar="aplicarFiltros"></Filters>

    <div class="mt-5 category-container-mobile">
      <FilterCategory :lista="categorias" @selecionar="selecionarCategoria" />
    </div>
  </div>
</template>

<script>
import FilterCategory from './FilterCategory.vue';
import Filters from './Filters.vue';

export default {
  name: 'MenuFilter',
  components: { FilterCategory, Filters },
  data() {
    return {
      buscaAtiva: false,
      isDesktop: window.innerWidth > 768,
      termoBusca: '',
      selectedLabel: 'Mais recente',
      opcoesOrdenacao: [
        { codigo: 1, nome: 'Mais recente' },
        { codigo: 2, nome: 'Mais relevante' }
      ],
      categorias: [
        { id: 0, nome: 'Todos os conteúdos', ativo: true },
        { id: 1, nome: 'Artigos' },
        { id: 2, nome: 'Comunicados' },
        { id: 3, nome: 'Eventos' },
        { id: 4, nome: 'Manuais' },
        { id: 5, nome: 'Notícias' },
        { id: 6, nome: 'Oportunidades' }
      ],
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isDesktop = window.innerWidth > 768;
    },
    ativarBuscaMobile() {
      this.buscaAtiva = true;
      this.$nextTick(() => { this.$refs.searchInput.focus(); });
    },
    checkBlur() {
      if (this.termoBusca === '') this.buscaAtiva = false;
    },
    selecionarOrdenacao(op) {
      this.selectedLabel = op.nome;
      this.$emit('selecionar-ordenacao', op.codigo);
    },
    selecionarCategoria(id) {
      this.categorias.forEach((c) => { this.$set(c, 'ativo', c.id === id); });
      this.$emit('selecionar-categoria', id === 0 ? null : String(id));
    },
    aplicarFiltros(filtros) {
      this.$emit('aplicar-filtros', filtros);
    },
    aplicarBusca() {
      this.$emit('buscar-termo', this.termoBusca.trim() || null);
    }
  }
}
</script>

<style scoped>
/* --- ESTILOS GERAIS --- */
.estilo-fonte {
  font-family: "Trebuchet MS", sans-serif;
  font-size: 16px;
  color: #212529;
}

::v-deep .dropdown-item {
  font-family: "Trebuchet MS", sans-serif !important;
  font-size: 14px !important;
  /* Ajuste para o tamanho desejado */
  color: #212529 !important;
  padding: 8px 16px;
  /* Espaçamento interno dos itens */
}

.custom-input {
  font-family: "Trebuchet MS", sans-serif;
  font-size: 16px;
  text-align: left;
  border-radius: 4px;
  border: 1px solid #CED4DA;
  outline: none !important;
  box-shadow: none !important;
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6C757D;
  cursor: pointer;
  font-size: 15px;
}

.label-desktop {
  margin-right: 8px;
}

.text-selected-label {
  color: #212529;
  font-family: "Trebuchet MS", sans-serif;
}

.transition-layout {
  transition: all 0.3s ease;
}

.btn-acao-mobile {
  color: #007A4A;
  font-family: "Trebuchet MS", sans-serif;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 6px 12px;
}

.btn-acao-mobile:hover {
  background-color: #e6f2ed;
}

/* --- MOBILE (@media 768px) --- */
@media (max-width: 768px) {
  ::v-deep .dropdown-menu {
    min-width: 180px;
    /* Deixa a lista mais larga que o botão para facilitar leitura */
    margin-top: 5px !important;
    /* Afasta um pouco do botão */
    padding: 5px 20px;
  }

  .btn-acao-mobile {
    flex-direction: row;
    justify-content: center;
    background-color: #F4F6F6;
    border-radius: 8px;
    height: 30px;
    padding: 0 5px;
    gap: 8px;
    width: 100%;
    /* Garante centralização vertical absoluta do conteúdo */
    align-content: center;
  }

  .btn-acao-mobile i {
    font-size: 16px;
    margin-bottom: 0 !important;
    display: flex;
    align-items: center;
  }

  .btn-acao-mobile span {
    font-size: 16px;
    display: flex;
    align-items: center;
  }

  .ordenar-wrapper {
    padding: 0 !important;
    overflow: visible !important;
  }

  ::v-deep .custom-dropdown {
    width: 100%;
    height: 100%;
    display: flex !important;
  }

  ::v-deep .custom-dropdown .dropdown-toggle {
    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    /* Centraliza ícone/texto verticalmente */
    justify-content: center !important;
    /* Centraliza horizontalmente */
    padding: 0 !important;
    color: #007A4A !important;
    font-size: 12px !important;
    gap: 8px;
    height: 100% !important;
    /* Ocupa toda a altura do pai (65px) */
    width: 100% !important;
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    line-height: 1 !important;
    /* Remove distorções de altura de linha */
  }
}

/* --- DESKTOP (@media 769px) --- */
@media (min-width: 769px) {
  .ordenar-wrapper {
    margin-top: 8px;
    display: flex;
    align-items: center;
  }

  .input-icon-container {
    margin-bottom: 15px;
  }

  .btn-acao-mobile {
    padding: 6px 12px;
  }

  ::v-deep .custom-dropdown .dropdown-toggle {
    padding: 0 !important;
    text-decoration: none !important;
    display: inline-flex !important;
    align-items: center;
  }
}

.input-icon-container {
  position: relative;
  width: 100%;
}

@media (max-width: 768px) {
  .category-container-mobile {
    width: 100% !important;
    overflow: visible !important;
    display: block !important;
  }
}
</style>